@if (getQty()) {
  <div>
    <div class="cursor-pointer p-b-1-s p-b-1-m flex flex-middle pos-relative"
      (click)="showStoreModal()">
      <ng-content></ng-content>
      <rating class="col-12 inline-block"
        [style.font-size.px]="13"
        [style.height.em]="1"
      [value]="getRating()"></rating>
      <span class="p2 p-l-2">({{ getQty() }})</span>
    </div>
  </div>
}
